<template>
  <div
    class="form-group"
    :class="{
      'form-group--inline': label_left,
      'form-group--disabled': disabled,
      'form-group--design-new': design === 'new'
    }"
  >
    <div v-if="label" class="form-group__top">
      <label :for="labelFor" class="form-group__label">{{ label }}<sup v-if="required">*</sup></label>
      <div v-if="$slots.additional" class="form-group__additional">
        <slot name="additional" />
      </div>
    </div>
    <div class="form-group__wrapper">
      <div class="form-group__body">
        <slot name="default" />
        <div v-if="$slots.right_place" class="form-group__right">
          <slot name="right_place" />
        </div>
      </div>
      <div v-if="$slots.error" class="form-group__error">
        <slot name="error" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppFormGroup',
  props: {
    labelFor: String,
    label: String,
    required: Boolean,
    label_left: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    },
  },
}
</script>

<style lang="sass">
.form-group
  margin-bottom: 20px

.form-group--mb38
  margin-bottom: 38px

.form-group--bottom-place
  position: relative

.form-group--center
  .form-group__top
    margin-bottom: 20px

.form-group--mh
  .form-group__body
    display: flex
    align-items: center
    min-height: 38px

.form-group--switcher
  .form-group__top
    margin-bottom: 17px

.form-group--no-indent
  margin-bottom: 0

.form-group--inline
  display: flex
  align-items: center
  gap: 10px

  .form-group__top
    margin-bottom: 0

.form-group--disabled
  .form-group__label
    font-weight: 400
    pointer-events: none

.form-group--self-start
  align-self: flex-start

.form-group__top
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 10px

.form-group__label
  font-size: 13px
  font-weight: 500

  &[for]
    cursor: pointer

  sup
    color: $color-error
    line-height: 0

.form-group__error
  color: $color-error
  font-size: 12px

  div:first-child
    margin-top: 5px

.form-group__body
  position: relative

.form-group__text
  margin-top: 10px
  font-size: 14px

.form-group__right
  position: absolute
  top: 50%
  right: 20px
  line-height: 0
  transform: translateY(-50%)

  button
    line-height: 0

.form-group__additional
  display: flex
  align-items: center
  gap: 10px

.form-group__additional-btn
  line-height: 0

.form-group__oye
  display: grid
  grid-template-columns: 1fr auto

  .btn
    margin-left: 20px

.form-group--design-new
  margin-bottom: $ui-space-20
  font-family: $ui-font-body

  .form-group__top
    margin-bottom: $ui-space-8

  .form-group__label
    color: $ui-text
    font-size: $ui-font-size-metadata
    font-weight: 600
    line-height: 1.4

    sup
      color: $ui-red

  .form-group__error
    color: $ui-red
    font-size: $ui-font-size-metadata

  &.form-group--disabled
    opacity: .72
</style>
